import type { AnnotationLabels } from './types'

const escapeHtml = (unsafe: string) =>
  unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

export const prepareLabels = (labels: AnnotationLabels) =>
  labels.map((l) => ({
    id: l.id,
    name: escapeHtml(l.name),
    color: l.color.code,
  }))
